import { Component, ElementRef, Injector, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ReservationService } from '../../reservations.service';
import { T2LoadingService } from '../../../../trip2-theme/components/t2-loading/t2-loading.service';
import { GridOptions } from 'ag-grid';
import { ManifestService } from '../../../A2-utils/manifest/manifest.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BooleanCheckComponent } from '../../../A2-utils/grid-components/boolean-check/boolean-check.component';
import * as moment from 'moment';
import { Subscription } from 'rxjs/Subscription';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';
import { constant } from 'app/app.constants';

@Component({
  selector: 'app-report-claims',
  templateUrl: './report-claims.component.html',
  styleUrls: ['./report-claims.component.scss']
})
export class ReportClaimsComponent extends ParentModule implements OnInit, OnChanges, OnDestroy {

  public rowData: any;
  public gridClaims: GridOptions;
  protected dataTripManifes: any;
  protected pdfurl: SafeResourceUrl;
  private observables: Subscription[] = [];
  private eobObjectUrl: string | null;
  protected tabClaim = 1;
  protected claimNumber: any;
  protected claimId: any;
  protected manifest: any;
  protected eop: boolean;
  protected isTripManifest = false;
  companyId: any;
  @Input() isStandingOrder = false;

  @Input() tripId: any;
  @ViewChild('reportClaim')     private reportClaim: ElementRef;
  @ViewChild('reportEop')       private reportEop: ElementRef;


  constructor(
    protected sanitizer: DomSanitizer,
    protected _reservation: ReservationService,
    protected _loading: T2LoadingService,
    protected _manifest: ManifestService,
    private sweetAlertHelper: SweetAlertHelper,
    protected Injector: Injector
  ) {
    super('app-unprocessed-claims', Injector);
    this.gridClaims = <GridOptions> {};
    this.gridClaims.enableColResize = true;
    this.gridClaims.rowSelection = 'single';
    this.gridClaims.columnDefs = this.createColumDef();
    this.gridClaims.overlayNoRowsTemplate = '<span>This trip has no claims.</span>';
    this.actionTripManifest();
  }

  ngOnInit() {
    this.gridClaims.onGridReady     = (data) => {
      this.gridClaims.api.sizeColumnsToFit();
    };
    this.observables.push(
      this._reservation.companySelectedObs$.subscribe({
        next: (value) => {
          if (value) {
            this.companyId = value;
          }
        },
        error: (err) => {
          this.sweetAlertHelper.captureException(err);
        },
      })
    );
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tripId'].currentValue) {
      this.getReportClaim(changes['tripId'].currentValue);
      this.getDataTripManifest(changes['tripId'].currentValue);
    }
  }

  actionTripManifest () {
    this.actionsList$.subscribe({
      next: (value) => {
        if (value && value.length) {
          this.isTripManifest = value.includes('View');
          this.getDataTripManifest(this.tripId);
        }
      }
    });
  }

  /**
   * @method getReportClaim
   * @description load the claims on the grid
   */
  getReportClaim(tripId) {
    this._loading.show();
    this.observables.push(
    this._reservation.getReportClaims(tripId)
      .finally(() => {
        this._loading.hiden();
      })
      .subscribe(success => {
        this.modificRowData(success);
        this.normalizeDates(success);
      }, error => this.sweetAlertHelper.captureException(error)));
  }

  /**
   * @method getDataTripManifest
   * @description Bring the trip data to compare with the manifest.
   */
  getDataTripManifest(tripId: number) {
    if (this.isTripManifest && tripId) {
      this.observables.push(
        this._manifest.getManifest(tripId).subscribe({
          next: (success) => {
            if (success) {
              this.dataTripManifes = success;
            }
          },
          error: (err) => {
            this.sweetAlertHelper.captureException(err);
          },
        })
      );
    }
  }

  /**
  * @method selectDocument
  * @description brings and shows the selected document in the grid
  */
  selectDocument(event) {
    this.claimId = event.data.providerclaimid;
    this.manifest = event.data.manifest;
    this.claimNumber = event.data.providerclaimtripid;
    this.showClaim(this.claimNumber);
    this.showManifest(this.manifest);

    this.eop = true;
    this.showEob(this.claimNumber);
  }

  /**
   * @method showClaim
   * @description bring claim report to show
   */
  showClaim(id) {
    this.reportClaim.nativeElement.src = '';
    // this.cardClaimReport.viewProgressBar(true);
    this._loading.show();
    this.observables.push(
    this._reservation.getRepotClaim(id)
          .finally(() => {
            this._loading.hiden();
            // this.cardClaimReport.viewProgressBar(false);
          })
          .subscribe(
            (success) => {
              if (success.status === 200) {
                const name = 'ECR-' + id + '.pdf';
                this.reportClaim.nativeElement.src = URL.createObjectURL(success.blob(), name);
              } else {
                // this.cardClaimReport.close();
                this.sweetAlertHelper.createCustomAlert({
                  title: 'Claim Report',
                  type: 'info',
                  text: 'Claim ' + success.statusText
                });
              }
            },
            (error) => {
              this.sweetAlertHelper.createCustomAlert({
                title: 'Claim Report',
                type: 'error',
                text: 'Claim ' + error.statusText
              });
            }
          ));
  }

  /**
   * @method showEob
   * @description bring the EOB report to show it
   */
  showEob(providerClaimTripId) {
    this.revokeEobObjectUrl();
    this.reportEop.nativeElement.src = '';
    this._loading.show();
    this.observables.push(
    this._reservation.getEobPdf(providerClaimTripId)
      .finally(() => {
        this._loading.hiden();
      })
      .subscribe(
        (success) => {
          this.revokeEobObjectUrl();
          this.eobObjectUrl = URL.createObjectURL(success.blob());
          this.reportEop.nativeElement.src = this.eobObjectUrl;
        },
        (error) => {
          this.eop = false;
          if (error.status === 404) {
            this.sweetAlertHelper.createCustomAlert({
              title: 'EOB Report',
              type: 'info',
              text: constant.MESSAGE_EOB_NOT_AVAILABLE
            });
            return;
          }
          this.sweetAlertHelper.captureException(error);
        }
      ));

  }

  /**
   * @method showManifest
   * @description Bring the manifest document to show it
   */
  showManifest(manifest) {

  }


  /**
   * @method modificRowData
   * @description modifica la data y Carga la grilla
   */
   modificRowData(data) {
    data.forEach(row => {
      if (row.manifest) {
        row.activemanifest = true;
      } else {row.activemanifest = false; }
    });
    this.rowData = data;
    if (!data.length) {
      this.gridClaims.api.showNoRowsOverlay();
    }
    this.gridClaims.api.sizeColumnsToFit();
   }

  /**
   * @method normalizeDates
   * @description Modifica las fechas al formato requerido
   */
  normalizeDates(dates: any) {
    dates.forEach(row => {
      if (row.denieddate) {
        row.denieddate = moment(row.denieddate)
          .format('YYYY-MM-DD HH:mm:ss');
      }
      if (row.appealeddate) {
        row.appealeddate = moment(row.appealeddate)
          .format('YYYY-MM-DD HH:mm:ss');
      }
      row.addedon = moment(row.addedon)
        .format('YYYY-MM-DD HH:mm:ss');
    });
  }

  /**
   * @method createColumDef
   * @description Carga las columnas a la grilla
   */
  createColumDef() {
    return  [
      {
        headerName: 'Date',
        field: 'addedon',
        colId: 'dateClaimid',
        width: 60
      },
      {
        headerName: 'Claim Number',
        field: 'providerclaimtripid',
        colId: 'claimid',
        width: 40
      },
      {
        headerName: 'Denial',
        field: 'denieddate',
        colId: 'denieddate',
        width: 60
      },
      {
        headerName: 'Reason for Denial',
        field: 'deniedreason',
        colId: 'denieddate',
        width: 70
      },
      {
        headerName: 'Appealed',
        field: 'appealeddate',
        colId: 'appealeddate',
        width: 60
      },
      {
        headerName: 'Status',
        valueGetter: (params) => {
          if (params && params.data) {
            return params.data.paymentstatus || 'No status';
          }
        },
        colId: 'paymentstatus',
        width: 70
      },
      {
        headerName: 'Manifest',
        field: 'activemanifest',
        colId: 'manifest',
        width: 30,
        cellRendererFramework: BooleanCheckComponent,
      },
    ];
  }

  private revokeEobObjectUrl(): void {
    if (this.eobObjectUrl) {
      URL.revokeObjectURL(this.eobObjectUrl);
      this.eobObjectUrl = null;
    }
  }

  ngOnDestroy(): void {
    this.observables.forEach(item => item.unsubscribe());
    this.revokeEobObjectUrl();
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/edit-reservation/report-claims/report-claims.component.ts